/** Centralized route paths — import these instead of hard-coding strings. */
export const ROUTES = {
  home: '/home',
  portfolios: '/portfolios',
  portfolioList: '/portfolio-list',
  mutualFund: '/mutual-fund',
  terms: '/terms',
  users: '/users',
  /**
   * OAuth callback — the exact path Barita redirects back to after
   * authenticating the user. Public (not behind `ProtectedRoute`): it is the
   * only route that reads `access_token`/`state` off the URL. Keep this in
   * sync with `VITE_OAUTH_REDIRECT_URI` if that env var is set explicitly.
   */
  authCallback: '',
  welcome: '/welcome',
  profile: '/profile',
  incomeCalendar: '/income-calendar',
  performance: '/performance',
  holdings: '/holdings',
  transactions: '/transactions',
  accountInfo: '/account-info',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
